import React, { Component } from 'react'
import Login from './scenes/Login'
import Main from './scenes/Main'
import ErrorPage from './scenes/Error'

// Clear any session whose JWT was minted before the DB-backed permission
// model rollout (marked with `v: 2`). Forces one re-login that returns a
// token carrying the new permission vocabulary. See
// administrators/docs/deploy.md.
//
// The S3 login cutover deliberately does NOT extend this check to the
// `currentAdmin` shape change (`username` → `email`). Doing so would log every
// admin out on the deploy and force them all through the new <cl-login> at once
// with the old React login already removed. Readers go through the
// Helpers/adminEmail alias instead, so pre-cutover sessions keep working and
// only new logins exercise the component.
const readAuthToken = () => {
  const token = window.localStorage.getItem('auth-token')
  if (!token) return null

  try {
    const payload = JSON.parse(window.atob(token.split('.')[1]))
    if (payload.v === 2) return token
  } catch {
    // Fall through to clear — a malformed token is not usable anyway.
  }

  window.localStorage.removeItem('auth-token')
  window.localStorage.removeItem('currentAdmin')
  return null
}

class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError (error) {
    // Update state so the next render will show the fallback UI.
    console.log('getDerivedStateFromError')
    return { hasError: true }
  }

  componentDidCatch (error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    console.log('caught error')
    console.log('error', error)
    console.log('errorInfo', errorInfo)
  }

  render () {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <ErrorPage />
      )
    }

    return this.props.children
  }
}

class App extends Component {
  constructor (props) {
    super(props)

    const authToken = readAuthToken()
    this.state = {
      authToken,
      currentAdmin: authToken ? window.localStorage.getItem('currentAdmin') : null
    }

    this._login = this._login.bind(this)
    this._logout = this._logout.bind(this)
  }

  render () {
    const { authToken } = this.state

    // For some reason currentAdmin state is converted to string undefined...
    // This is just temp code to ensure that things work even
    // without changes from API
    const currentAdmin =
      this.state.currentAdmin && this.state.currentAdmin !== 'undefined'
        ? JSON.parse(this.state.currentAdmin)
        : null

    if (!authToken) {
      return (<Login login={this._login} />)
    }

    return (
      <ErrorBoundary>
        <Main
          authToken={authToken}
          currentAdmin={currentAdmin}
          logout={this._logout}
        />
      </ErrorBoundary>
    )
  }

  _logout () {
    window.localStorage.removeItem('auth-token')
    window.localStorage.removeItem('currentAdmin')
    this.setState({ authToken: null, currentAdmin: null })
    window.location = '/'
  }

  _login (token, admin) {
    this.setState({ authToken: token, currentAdmin: admin })
  }
}

export default App
